<template>
    <div>

        <div v-if="mode === 'store'">
            <div v-for="s in projectedByStoreItems">
                <h5>{{ s.store.name }}</h5>

                <div class="card-container mb-3">
                    <b-card v-for="e in s.entries" :key="e.programName" :class="cellClasses(e)">
                        <div class="mb-1">
                            <strong>{{ e.programName }}</strong>
                        </div>
                        <bp-bean :store-id="s.store.id" :program-id="e.programId" :counts="e"
                            :show-labels="showLabels" :consignment="e.programName.includes('(Consignment')" />
                        <div v-if="e.programSeparateQueue" class="mt-1">
                            <b-badge variant="warning" style="display:block;">Separate Queue</b-badge>
                        </div>
                        <div v-if="false">
                            {{ e }}
                        </div>
                    </b-card>
                </div>
            </div>
        </div>

        <b-row v-if="mode !== 'store'">
            <b-col>
                <b-table :fields="fields" :items="projectedItems" hover bordered>
                    <template #cell(programName)="row">
                        <div class="d-flex align-items-center" style="gap:7px;">
                            <span>{{ row.value }}</span>
                            <b-badge v-if="row.item.programSeparateQueue" variant="warning" class="mb-0">
                                Separate Queue
                            </b-badge>
                        </div>
                    </template>
                    <template #cell()="row">
                        <bp-bean :store-id="row.field.key" :program-id="row.item.programId"
                            :counts="row.value" :show-labels="showLabels"
                            :consignment="row.item.programName.includes('(Consignment')" />
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DashboardStatus } from '@/models/DashboardStatus'
import { BvTableFieldArray } from "bootstrap-vue";
import { Store } from '@/models/Store'
import PrintQueueTableBadges from './PrintQueueTableBadges.vue';

@Component({
    name: "PrintQueueTable",
    components: {
        "bp-bean": PrintQueueTableBadges
    }
})
export default class PrintQueueTable extends Vue {
    @Prop({ default: () => [], }) private status!: Array<DashboardStatus.PrintQueueStatus>;
    @Prop({ default: () => null, }) private sList!: Array<Store> | null;
    @Prop({ default: "store" }) private mode!: string;
    @Prop({ default: false }) private showLabels!: boolean;

    get fields(): BvTableFieldArray {
        const fields = [];
        fields.push({ key: "programName", label: "", });

        const stores = this.status.flatMap(s => s.printQueueRowRecord.map(r => r.storeName));

        this.sList?.forEach(sL => {
            if (!stores.find(s => sL.name == s)) return;

            fields.push({
                key: sL.id.toString(),
                label: sL.name,
                class: "store-col",
                tdClass: this.cellClasses
            });
        })

        return fields;
    }

    cellClasses(value: any) {
        if (value.dateDays > 4) return "table-danger";
        if (value.dateDays > 2) return "table-warning";
        return "";
    }

    get projectedItems() {
        return this.status.map(st => {
            const item: any = {
                programName: st.programName,
                programId: st.programId,
                programSeparateQueue: st.programSeparateQueue,
            };

            st.printQueueRowRecord.forEach((pqr: any) => {
                const uniqueId = pqr.storeId.toString();
                item[uniqueId] = pqr;
            });
            return item;
        });
    }

    get projectedByStoreItems() {
        return this.sList?.map(store => {
            const uniqueId = store.id.toString();

            return {
                store,
                entries: this.projectedItems.filter(pi => pi[uniqueId])
                    .map(pi => ({
                        programName: pi.programName,
                        programId: pi.programId,
                        programSeparateQueue: pi.programSeparateQueue,
                        ...pi[uniqueId]
                    }))
            };
        }).filter(i => i.entries.length);
    }
}
</script>

<style scoped>
h5 {
    position: sticky;
    top: 0;
    background: white;
    z-index: 100;
}

.card-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 230px), 1fr));
    gap: 10px;

    .card {
        box-shadow: none;
        margin-bottom: 0;
    }
}

.card-container ::v-deep(.badge-sash)>* {
    width: 33.3%;
}

.card-container ::v-deep(.badge-sash) .badge {
    width: 100%;
}

.card-container .card.table-danger {
    background: #f5c6cb;
}

::v-deep(.store-col) {
    width: 60px;
}
</style>
